import LOGO from '../static/icons/tag.png';

export const APP_NAME = 'Boilerplate';
export const APP_LOGO = LOGO

export const API_HOST = 'https://meet-api.appscrip.co/';
export const BASIC_AUTH = 'Basic bWVldC5hcHBzY3JpcEBnbWFpbC5jb206M0VtYmVkMDA3'